/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLogicBuffer = createReactComponent("outline", "logic-buffer", "IconLogicBuffer", [["path", { "d": "M22 12h-5", "key": "svg-0" }], ["path", { "d": "M2 9h5", "key": "svg-1" }], ["path", { "d": "M2 15h5", "key": "svg-2" }], ["path", { "d": "M7 5l10 7l-10 7z", "key": "svg-3" }]]);

export { IconLogicBuffer as default };
//# sourceMappingURL=IconLogicBuffer.mjs.map
